import Informations from 'pages/CatalogPage/DH/Tires/Informations/Informations';

export default Informations;
